import React, { useState } from "react";
import { PurchaseButton, SoldModalButton } from "../../UIkit";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import "../../../assets/css/sliderBox.css";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { withStyles } from "@material-ui/core/styles";

// import { StripeComponent } from "..";
// import { loadStripe } from "@stripe/stripe-js";

// const stripePromise = loadStripe(
//   "pk_test_51IsKsuKSlIImOvRf2bQwEE4nGMO7MqEmLaVztpbH78eDwKTC84akt2XPCQO263BE9M5t6t75s6rQVEn6f2QKMPjr00rmRPN9xh"
// );
// import { StatesModal } from "..";

const WhiteTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 13,
    padding: 15,
    marginBottom: 50,
    whiteSpace: "pre-wrap",
    // marginLeft: 150,
  },
}))(Tooltip);

// const WhiteSizeTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//     marginBottom: 50,
//     marginLeft: 150,
//   },
// }))(Tooltip);

// const WhitePriceTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//     marginBottom: 50,
//     marginLeft: 0,
//   },
// }))(Tooltip);

// const WhiteDescriptionTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//     marginBottom: 50,
//     marginLeft: 0,
//   },
// }))(Tooltip);

const SliderMenu = (props) => {
  const [sizeOpen, setSizeOpen] = useState(false);
  const [priceOpen, setPriceOpen] = useState(false);
  const [descriptionOpen, setDescriptionOpen] = useState(false);

  const sizeTooltipClose = () => {
    setSizeOpen(false);
  };
  const sizeTooltipOpen = () => {
    setSizeOpen(true);
  };

  const priceTooltipClose = () => {
    setPriceOpen(false);
  };
  const priceTooltipOpen = () => {
    setPriceOpen(true);
  };

  const descriptionTooltipClose = () => {
    setDescriptionOpen(false);
  };
  const descriptionTooltipOpen = () => {
    setDescriptionOpen(true);
  };

  return (
    <>
      <div className="flex-column--justbottom">
        <div className="title-box__text center ">{props.name}</div>
        <div className="spacer-box--ss"></div>
        <div className="text-white">
          <div className="flex-row--around slider-menu-box">
            <ClickAwayListener onClickAway={sizeTooltipClose}>
              <div>
                <WhiteTooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={sizeTooltipClose}
                  open={sizeOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  placement="top-start"
                  title={props.size}
                >
                  <AspectRatioIcon className="hover1" style={{ fontSize: 22 }} onClick={sizeTooltipOpen} />
                </WhiteTooltip>
              </div>
            </ClickAwayListener>
            <ClickAwayListener onClickAway={priceTooltipClose}>
              <div>
                <WhiteTooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={priceTooltipClose}
                  open={priceOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  placement="top"
                  title={"¥" + props.price}
                >
                  <LocalAtmIcon className="hover1" style={{ fontSize: 22 }} onClick={priceTooltipOpen} />
                </WhiteTooltip>
              </div>
            </ClickAwayListener>
            <ClickAwayListener onClickAway={descriptionTooltipClose}>
              <div>
                <WhiteTooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  onClose={descriptionTooltipClose}
                  open={descriptionOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  placement="top"
                  title={props.description}
                >
                  <DescriptionOutlinedIcon
                    className="hover1"
                    style={{ fontSize: 22 }}
                    onClick={descriptionTooltipOpen}
                  />
                </WhiteTooltip>
              </div>
            </ClickAwayListener>
            {/* <StatesModal /> */}
          </div>
          <div className="spacer-box--s"></div>
          {props.isSold === false ? (
            <PurchaseButton
              label="購入"
              price={props.price}
              name={props.name}
              images={props.images}
              boothId={props.boothId}
              id={props.id}
              uid={props.uid}
            />
          ) : (
            <SoldModalButton
              title="この作品は売却済みです"
              text="売却済み作品に投票できる機能を開発中です"
              // onClick={} 投票機能
              label="売却済"
              className="top-back-btn"
            />
          )}
        </div>
        <div className="spacer-box--m"></div>
      </div>
    </>
  );
};

export default SliderMenu;
